import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  grid: {
    display: 'grid',
    textAlign: 'left',
    gridTemplateColumns: '37% 63%',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    },
    marginTop: theme.spacing(2)
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginRight: 'initial'
    }
  }
}));